import axios from 'axios';
import { withFreshAuth } from './freshAuth';
import { ENDPOINTS } from '../config/endpoints';

const API_BASE_URL = ENDPOINTS.tts;

const api = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
});

api.interceptors.request.use(withFreshAuth);

export const ttsService = {
  async synthesize(text, voice = 'default', format = 'wav', temperature = 0.7, adaptText = false, rate = null, preparedText = null) {
    const response = await api.post('/synthesize', {
      text, voice, format, temperature, adapt_text: adaptText, rate,
      // Текст, поправленный человеком в предпросмотре: уходит в синтез как есть
      prepared_text: preparedText,
    });
    return response.data;
  },

  async getStatus(taskId) {
    const response = await api.get('/get_status', { params: { task_id: taskId } });
    return response.data;
  },

  async getFile(taskId) {
    const response = await api.get('/get_file', {
      params: { task_id: taskId },
      responseType: 'blob',
    });
    return URL.createObjectURL(response.data);
  },

  async getVoices() {
    const response = await api.get('/voices');
    return response.data;
  },

  async previewAdapt(text) {
    const response = await api.post('/preview_adapt', { text });
    // prepared_text — как текст прочитает Silero, с расставленными ударениями
    return { adapted: response.data.adapted_text, prepared: response.data.prepared_text };
  },

  async uploadVoice(audioBlob) {
    const form = new FormData();
    form.append('audio', audioBlob, 'recording.webm');
    const response = await api.post('/voices/upload', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data;
  },

  async saveVoice(tmpId, name) {
    const response = await api.post('/voices/save', { tmp_id: tmpId, name });
    return response.data;
  },

  async deleteVoice(voiceId) {
    const response = await api.delete(`/voices/${voiceId}`);
    return response.data;
  },
};
